module.exports = __webpack_public_path__ + "static/img/nose_03.68c1cdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/noses/thumbnail/nose_03.png
// module id = 8TET
// module chunks = 0